import React, { Component } from "react";
import DdlManager from "../DdlManager";
import Script from "react-load-script";
import AnalyticsContext, { DTM_EVENTS_DOM_ELEMENT } from "../analytics-context";
import AdobeAppMeasurement from "../AdobeAppMeasurement";

const USER_INFO = {
  loginStatus: "not logged-in",
  custType: "GUEST"
};

class AdobeAnalytics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      analytics: {
        dtmIsReady: false,
        digitalData: {
          user: USER_INFO
        },
        actions: {
          dtmIsReady: this.dtmIsReady.bind(this),
          updateDigitalData: this.updateDigitalData.bind(this),
          ddlIsDirty: this.ddlIsDirty.bind(this)
        }
      }
    };
  }

  scriptLoaded = () => {
    this.dtmIsReady(true);
  };

  dtmIsReady(val) {
    this.setState({
      analytics: {
        ...this.state.analytics,
        dtmIsReady: val
      }
    });
  }

  updateDigitalData(digitalData) {
    this.setState({
      analytics: {
        ...this.state.analytics,
        digitalData: {
          user: USER_INFO,
          ...digitalData
        },
        ddlIsDirty: true
      }
    });
  }

  ddlIsDirty(val) {
    this.setState({
      analytics: {
        ...this.state.analytics,
        ddlIsDirty: val
      }
    });
  }

  render() {
    return (
      <AnalyticsContext.Provider value={this.state.analytics}>
        <div id={DTM_EVENTS_DOM_ELEMENT} />
        <Script
          url={
            window.location.hostname === "localhost"
              ? "//assets.adobedtm.com/fb2536241e31a607daba5441f44190425fd3eafa/satelliteLib-aecfe7f7408a907fda561aab642ab35ccc0d0eec-staging.js"
              : "//assets.adobedtm.com/fb2536241e31a607daba5441f44190425fd3eafa/satelliteLib-aecfe7f7408a907fda561aab642ab35ccc0d0eec.js"
          }
          onLoad={this.scriptLoaded}
        />
        <DdlManager />
        <AdobeAppMeasurement />
        {this.props.children}
      </AnalyticsContext.Provider>
    );
  }
}

export default AdobeAnalytics;
